import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchEstimatedHarvests(producer_id, harvest_process_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/show_harvest_process/${producer_id}/fetch_estimated_harvests/${harvest_process_id}`
    );
  },

  fetchHarvestProcessCropSizeGroups(producer_id, harvest_process_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/show_harvest_process/${producer_id}/fetch_harvest_process_crop_size_groups/${harvest_process_id}`
    );
  },

  fetchEstimatedContainers(producer_id, harvest_process_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/show_harvest_process/${producer_id}/fetch_estimated_containers/${harvest_process_id}`
    );
  },

  fetchHarvestProcess(producer_id, harvest_process_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/show_harvest_process/${producer_id}/fetch_harvest_process/${harvest_process_id}`
    );
  }
};
